export default __webpack_public_path__ + "static/media/twist-logo.aa957115.png";